import axios from 'axios';
import conf from '@/config';
import { Message } from 'element-ui';

const NODE_ENV = process.env.NODE_ENV;

const ssoUrlLogin = conf.ssoPath + '/login?service=';

const login = (res) => {
	const data = res.data;
	Message.error({
		message: data.msg ? data.msg : data.toString(),
	});

	setTimeout(() => {
		if (conf.env === 'business') {
			window.location.href = location.pathname + '/#/login';
		} else {
			window.location.href = ssoUrlLogin + encodeURI(`${conf.host}/questionnaire/#/list`);
		}
	}, 500);
};

const errors = (err) => {
	const msg = err.code === 'ECONNABORTED' ? '网络超时，请刷新重试' : err.msg || err.message || err.toString();
	Message.error({
		message: msg,
	});
	console.error(err);

	if (err.response) {
		if (err.response.status === 401) {
			login(err.response);
		}
		if (err.response.data) {
			Message.error({
				message: err.response.data.msg,
			});
		}
	}
	return err.response;
};

const filter = (res) => {
	const { status, data } = res;
	if (status >= 200 && status < 300) {
		if (data.code === 0 || data.status === 0) {
			res.ok = true;
			return res;
		} else if (data.code == 401) {
			login(res);
		} else if (typeof data === 'string') {
			return res;
		}
	}
	console.info(res);
	errors(data);
	res.ok = false;
	return res;
};

const httpCreate = (baseUrl, timeout = 600e3) => {
	const http = axios.create({
		baseURL: conf.host + baseUrl,
		timeout,
		headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
	});
	http.interceptors.response.use(filter, errors);
	return http;
};
const url = (path) => {
	return `${conf.host}/api/${path}`;
};

const urlfull = (path) => {
	return `${conf.host}${conf.surveyApipath}${path}`;
};

export { login, errors, filter, httpCreate, urlfull, url };
